export { default } from "./CategoryFilters.jsx";
